import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-554fcf3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "schedule-grid" }
const _hoisted_2 = { id: "schedule-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "List of Availability & Appointment", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Submit", -1))
const _hoisted_6 = { id: "calendar-block" }

import {
  FormInst, FormRules, NForm, NFormItem,
  NButton, NSpace, SelectOption, NDatePicker,
  NSelect, FormItemRule
} from "naive-ui"
import {PlusBox} from "mdue";
import ScheduleList from "@/components/ScheduleList.vue"
import Modal from "@/components/Modal.vue";
import {QuillEditor} from "@vueup/vue-quill";
import {ref} from "@vue/runtime-core";
import {useRouter} from "vue-router"
import {ScheduleModel} from "@/types/ScheduleModel";
import Calendar from "@/components/Calendar.vue"
import axios, {AxiosError} from "axios";
import {Schedule, ScheduleDto, ScheduleTypeDto} from "@/types/Schedule";
import {ValidateError} from "async-validator";
import {getCurrentInstance} from "vue";


// Initialize router

export default /*#__PURE__*/_defineComponent({
  __name: 'Schedule',
  props: {
    url: null,
    editable: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  url?: string,
  editable?: boolean
}

const router = useRouter();

const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message

const form = ref<FormInst | null>(null)
const model = ref<Schedule>({} as Schedule)
model.value.description = ''
const modal = ref(null)

let submitLoading = ref(false)
const scheduleKey = ref(1)

const schedule = ref<ScheduleModel[]>([])
const loaded = ref(false)
const currentPage = ref(1)

var scheduleTypes: SelectOption[] = []
const scheduleTypeOptions = ref<SelectOption[]>([])



const rules: FormRules = {
  start_time: [{
    required: true,
    type: 'number',
    message: "Start Time is required",
    trigger: ["change"]
  }],
  end_time: [{
    required: true,
    type: 'number',
    validator(rule: FormItemRule, value: Date) {
      if (!value) {
        return new Error('End Time is required')
      } else if (value < model.value.start_time) {
        return new Error('End Time must not be earlier than Start Time')
      }
    },
    trigger: ["change"]
  }],
  type: [{
    required: true,
    message: "Schedule Type is required",
    trigger: ["change"]
  }],
}


getSchedule(currentPage.value)

async function getSchedule(page: any) {
  await axios.get(props.url + `?page=${page}`)
      .then(response => {
        schedule.value = response.data.results
        loaded.value = true
        scheduleKey.value *= -1;
      })
      .catch(error => console.log(error))
}

async function handleSubmit(errors: ValidateError[][] | undefined) {
  if (!errors) {
    let payload = new ScheduleDto(model.value);
    submitLoading.value = true
    axios.post("/api/schedule/", payload)
        .then(_val => {
          message.success("Schedule is successfully added!", {showIcon: true, closable: true});
          getSchedule(currentPage.value);
          submitLoading.value = false;
          (modal.value as any).showModal = false;
          (model.value as any) = {};
        })
        .catch((_err: AxiosError) => {
          submitLoading.value = false;
          message.error("A problem is occurred when updating schedule", {showIcon: true, closable: true});
        })
  }
}

function handleModalOnClick() {
  axios.get("/api/schedule/type").then(response => {
    scheduleTypes = response.data.map((i: ScheduleTypeDto) => {
      return {value: i.name, label: i.name}
    })
    scheduleTypeOptions.value = scheduleTypes
  }).catch((err: AxiosError) => {
    message.error("Cannot load list of schedule types", {showIcon: true, closable: true});
  })
}

function scheduleTypeSearch(query: string) {
  if (!query.length) {
    scheduleTypeOptions.value = scheduleTypes
  } else {
    var res: SelectOption[] = scheduleTypes.filter((item) => ~item.value.toString().toLowerCase().indexOf(query.toLowerCase()))
    scheduleTypeOptions.value = res
  }
}

function handleSubmitButtonClick(e: MouseEvent) {
  e.preventDefault();
  form.value!.validate(handleSubmit).catch(_error => {
    message.error("Form is invalid", {showIcon: true, closable: true})
  })
}

function onScheduleDelete() {
  getSchedule(currentPage.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NSpace), {
        vertical: "",
        align: "center"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(Modal, {
        ref_key: "modal",
        ref: modal
      }, {
        trigger: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: "service",
            id: "tambah",
            onClick: handleModalOnClick
          }, [
            _createVNode(_unref(PlusBox), { style: {"font-size":"32px"} }),
            _createTextVNode(" Add new schedule ")
          ], 512), [
            [_vShow, __props.editable]
          ])
        ]),
        content: _withCtx(() => [
          _createVNode(_unref(NForm), {
            ref_key: "form",
            ref: form,
            model: model.value,
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NFormItem), {
                id: "startTimeForm",
                path: "start_time",
                label: "Start Time"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NDatePicker), {
                    placeholder: "Select Date and Time",
                    value: model.value.start_time,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.value.start_time) = $event)),
                    type: "datetime"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(NFormItem), {
                id: "endTimeForm",
                path: "end_time",
                label: "End Time"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NDatePicker), {
                    placeholder: "Select Date and Time",
                    value: model.value.end_time,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((model.value.end_time) = $event)),
                    type: "datetime"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_unref(NFormItem), {
                id: "typeForm",
                path: "type",
                label: "Schedule Type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSelect), {
                    placeholder: "Select Schedule Type",
                    value: model.value.type,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((model.value.type) = $event)),
                    options: scheduleTypeOptions.value,
                    filterable: "",
                    clearable: "",
                    remote: "",
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                    onSearch: scheduleTypeSearch,
                    size: "large"
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              (model.value.type === 'Appointment')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createTextVNode(" Description "),
                    _createVNode(_unref(QuillEditor), {
                      theme: "snow",
                      "content-type": "html",
                      content: model.value.description,
                      "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((model.value.description) = $event)),
                      placeholder: "Description"
                    }, null, 8, ["content"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(NButton), {
                id: "submitBtn",
                type: "primary",
                "attr-type": "submit",
                size: "large",
                onClick: handleSubmitButtonClick,
                loading: _unref(submitLoading)
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 512),
      (loaded.value)
        ? (_openBlock(), _createBlock(ScheduleList, {
            schedules: schedule.value,
            key: scheduleKey.value,
            editable: __props.editable,
            onScheduleDelete: onScheduleDelete
          }, null, 8, ["schedules", "editable"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Calendar, {
        style: {"height":"100%"},
        schedules: schedule.value
      }, null, 8, ["schedules"])
    ])
  ]))
}
}

})